import {Component, OnDestroy, OnInit} from '@angular/core';
import {Apollo, gql} from 'apollo-angular';
import {catchError, EMPTY, map, Subscription} from 'rxjs';
import {ErrorService} from 'src/app/shared/services/error.service';
import {SideNav_getBuilderCount} from './__generated__/SideNav_getBuilderCount';

const GET_BUILDER_COUNT = gql`
  query SideNav_getBuilderCount {
    builderOptions {
      totalCount
    }
  }
`;

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false,
})
export class SideNavComponent implements OnInit, OnDestroy {
  builderCount: number | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private apollo: Apollo,
    private errorHandler: ErrorService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apollo
        .watchQuery<SideNav_getBuilderCount>({
          query: GET_BUILDER_COUNT,
        })
        .valueChanges.pipe(
          map(result => result.data?.builderOptions.totalCount ?? 0),
          catchError(error => {
            this.errorHandler.handleDefault(error);
            return EMPTY;
          }),
        )
        .subscribe(totalCount => (this.builderCount = totalCount)),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
